import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { UseFiltersValue } from '@components/filters';
import { Stack } from '@components/stack';

import { Box } from 'components/Box';
import { FilterButton } from 'components/FilterButton';
import { Header } from 'components/headers';
import { SearchButton } from 'components/SearchButton';
import { FilterState } from 'features/filters/create-filter-state-hook';

type FilterActionProps = {
  filters?: UseFiltersValue;
  filterState: FilterState;
  searchPlaceholder: string;
};

type FilterHeaderProps = FilterActionProps & {
  title: string;
  tabs?: JSX.Element;
};

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  title,
  filters,
  filterState,
  searchPlaceholder,
  children,
  ...rest
}) => (
  <Header
    // @ts-ignore
    breadcrumbs={<Breadcrumb items={[{ label: title }]} />}
    mobileTitle={title}
    actions={
      <FilterActions
        filters={filters}
        filterState={filterState}
        searchPlaceholder={searchPlaceholder}
      >
        {children}
      </FilterActions>
    }
    {...rest}
  />
);

const FilterActions: React.FC<FilterActionProps> = ({
  children,
  searchPlaceholder,
  filters,
  filterState,
}) => (
  <ActionsContainer flex justifyContent="space-between" backgroundColor="white100">
    <Stack orientation="horizontal" space={2} justify="flex-end">
      <SearchButton
        // @ts-ignore
        value={filterState.search}
        onChange={filterState.setSearchValue}
        clear={filterState.clear}
        isOpen={filterState.isSearchOpen}
        onClose={filterState.clear}
        onOpen={filterState.toggleSearchOpen}
        placeholder={searchPlaceholder}
      />
      {children}
      {filters && <FilterButton filters={filters} />}
    </Stack>
  </ActionsContainer>
);

const ActionsContainer = styled(Box).attrs({
  flex: true,
})({
  '@media(max-width: 480px)': {
    flexWrap: 'wrap-reverse',
  },
});
